import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiDetailPageHeader, MiTab } from "@miplatform/components";
import { useRouter } from "@miplatform/hooks";
import { Box } from "@mui/material";
import { CommunityContactsTab } from "./CommunityContactsTab/CommunityContactsTab";
import { CommunityHomesTab } from "./CommunityHomesTab/CommunityHomesTab";
import { CommunitySummaryTab } from "./CommunitySummaryTab/CommunitySummaryTab";
import { CommunityVendorsTab } from "./CommunityVendorsTab/CommunityVendorsTab";
import { CommunityInspectionAuthoritiesTab } from "./CommunityInspectionAuthoritiesTab/CommunityInspectionAuthoritiesTab";
import {
  COMMUNITY_DETAILS_TABS,
  COMMUNITY_DETAILS_TAB_ROUTES,
} from "./communityDetailsTabs";
import { useCommunityDetailsViewModel } from "./useCommunityDetailsViewModel";

export const CommunityDetails = () => {
  const router = useRouter();
  const {
    id: communityId,
    tab = COMMUNITY_DETAILS_TAB_ROUTES.SUMMARY,
  } = router.params;
  const { classes } = useStyles();

  const { community, isLoading, getCommunityDetails, updateCommunity } =
    useCommunityDetailsViewModel();

  const handleClickTab = (tab) => {
    router.navigate(`/communities/${communityId}/${tab}`);
  };

  useEffect(() => {
    getCommunityDetails(communityId);
  }, [communityId]);

  return (
    <Box className={classes.contentContainer}>
      <MiDetailPageHeader
        title={
          <Box display="flex" alignItems="center">
            {community?.name}
          </Box>
        }
        subTitles={["Community"]}
        loading={isLoading}
      />
      <MiTab
        tabs={COMMUNITY_DETAILS_TABS}
        currentTab={tab}
        onTabChange={handleClickTab}
        disabled={isLoading}
      />
      {tab === COMMUNITY_DETAILS_TAB_ROUTES.SUMMARY && (
        <CommunitySummaryTab
          community={community}
          contacts={community?.contacts}
          onSave={updateCommunity}
          loading={isLoading}
        />
      )}
      {tab === COMMUNITY_DETAILS_TAB_ROUTES.HOMES && (
        <CommunityHomesTab community={community} />
      )}
      {tab === COMMUNITY_DETAILS_TAB_ROUTES.CONTACTS && (
        <CommunityContactsTab
          community={community}
          reload={() => getCommunityDetails(communityId)}
        />
      )}
      {tab === COMMUNITY_DETAILS_TAB_ROUTES.SUPPLIERS && (
        <CommunityVendorsTab community={community} loading={isLoading} />
      )}
      {tab === COMMUNITY_DETAILS_TAB_ROUTES.INSPECTION_AUTHORITIES && (
        <CommunityInspectionAuthoritiesTab communityId={communityId} />
      )}
    </Box>
  );
};

const useStyles = makeStyles()(() => ({
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "inherit",
  },
}));
